import React from 'react';
import { Rate } from 'antd';
import classnames from 'classnames';
import { Checkbox } from 'components/Checkbox/Checkbox';
import { CSTooltip } from 'components/Tooltip/CSToolTip';
import './CheckboxGroup.scss';
import { QuestionCircleOutlined } from '@ant-design/icons';
import { ExclamationCircleOutlined } from '@ant-design/icons';
import { FlexContainer } from 'components/Containers/FlexContainer/FlexContainer';

const LabelComponentMap = {
  RateComponent: value => <Rate disabled defaultValue={value} />,
};

const SelectAllCheckbox = ({
  onSelectAll,
  isAllSelected,
  selectAllText,
  toolTip,
}) => {
  return (
    <li className="checkboxgroup-li-item">
      <Checkbox
        checked={isAllSelected}
        onChange={onSelectAll}
        onKeyPress={onSelectAll}
        tabIndex={0}
      >
        <FlexContainer>
          {selectAllText}
          {toolTip && (
            <CSTooltip
              placement="top"
              isInline={true}
              tooltipName={selectAllText}
              pagePosition="Filters"
              allowWrap={true}
              tooltipContent={toolTip}
            >
              <ExclamationCircleOutlined className="fontGray300 padT6" />
            </CSTooltip>
          )}
        </FlexContainer>
      </Checkbox>
    </li>
  );
};

const CheckboxRow = ({
  datatestid,
  option,
  values,
  onChange,
  filterName,
  disabled,
}) => {
  return (
    <li
      className="checkboxgroup-li-item"
      data-testid={datatestid ? `${datatestid}-item` : null}
    >
      <Checkbox
        value={option.value}
        checked={isValueChecked(option.value, values)}
        onChange={onChange}
        disabled={disabled}
        onKeyPress={onChange}
        tabIndex={0}
      >
        <>
          {option.labelComponent
            ? LabelComponentMap[option.labelComponent]?.(option.value)
            : option.label}
          {option.tooltip && (
            <CSTooltip
              datatestid={datatestid ? datatestid : null}
              placement="top"
              isInline={true}
              tooltipName={filterName}
              pagePosition="Filters"
              allowWrap={true}
              tooltipContent={
                <div>
                  <div
                    data-testid={datatestid ? `${datatestid}-tooltip` : null}
                  >
                    {option.tooltip}
                  </div>
                </div>
              }
            ></CSTooltip>
          )}
        </>
      </Checkbox>
    </li>
  );
};

const areAllElementsSelected = (values, options) => {
  if (values.length === options.length) {
    return true;
  }
  return false;
};

const isValueChecked = (selected, values) => {
  return !!values.find(v => v === selected);
};

function CheckboxGroup({
  datatestid,
  options,
  applySelectAllStyle,
  selectAllText,
  selectAllTooltip,
  onChange,
  values,
  initialText,
  pagePosition,
  toolTipClassName,
  outerClassName,
  innerClassName,
}) {
  console.log('applySelectAllStyle>>>>>>>', applySelectAllStyle);
  const shouldApplySelectAllStyle = applySelectAllStyle;
  const onSelectAll = e => {
    if (isAllSelected) {
      onChange([]);
    } else {
      onChange(options.map(o => o.value));
    }
  };
  const buildOnCheckboxClick = option => {
    const onCheckboxClick = e => {
      const selected = e.target.value;
      if (isValueChecked(selected, values)) {
        onChange(prevValues => prevValues.filter(value => value !== selected));
      } else {
        onChange(prevValues => {
          return prevValues ? [...prevValues, selected] : [selected];
        });
      }
    };

    return onCheckboxClick;
  };

  const isAllSelected = areAllElementsSelected(values, options);

  return (
    <div
      className={classnames('checkboxgroup-container', outerClassName)}
      data-testid={datatestid ? `${datatestid}-container` : null}
    >
      {
        <ul
          className={classnames('checkboxgroup-ul', innerClassName, {
            noSelectAll: !shouldApplySelectAllStyle,
          })}
          data-testid={datatestid ? `${datatestid}-list` : null}
        >
          <SelectAllCheckbox
            onSelectAll={onSelectAll}
            isAllSelected={isAllSelected}
            selectAllText={selectAllText}
            toolTip={selectAllTooltip}
          />
          {options.map((option, i) => {
            if (option.toolTip) {
              return (
                <li>
                  <FlexContainer>
                    <FlexContainer className="format95">
                      <ul className="pad0 list-none">
                        <CheckboxRow
                          datatestid={datatestid ? `${datatestid}-list` : null}
                          key={`${datatestid}-list-${i}`}
                          option={option}
                          values={values}
                          onChange={buildOnCheckboxClick(option)}
                          filterName={initialText}
                          disabled={option.disabled}
                        />
                      </ul>
                    </FlexContainer>
                    <FlexContainer className="format5">
                      <CSTooltip
                        title={option.toolTip.title}
                        tooltipContent={
                          <div
                            className="margT20"
                            dangerouslySetInnerHTML={{
                              __html: option.toolTip.tooltipContent,
                            }}
                          />
                        }
                        isInline
                        placement={option.toolTip.placement}
                        tooltipName={option.toolTip.tooltipName}
                        pagePosition={pagePosition}
                        className={toolTipClassName}
                      >
                        <QuestionCircleOutlined className="fontGray300" />
                      </CSTooltip>
                    </FlexContainer>
                  </FlexContainer>
                </li>
              );
            } else {
              return (
                <CheckboxRow
                  datatestid={datatestid ? `${datatestid}-list` : null}
                  key={`${datatestid}-list-${i}`}
                  option={option}
                  values={values}
                  onChange={buildOnCheckboxClick(option)}
                  filterName={initialText}
                  disabled={option.disabled}
                />
              );
            }
          })}
        </ul>
      }
    </div>
  );
}

export { CheckboxGroup };
